import * as React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import { push } from 'connected-react-router';
import { withRouter, RouteComponentProps } from 'react-router';
import qs from 'qs';

// Selectors
import RoleGate from 'components/RoleGate';

// Types
import { Roles } from 'components/RoleGate/types';

interface OwnProps extends RouteComponentProps {
    params?: {
        [param: string]: any;
    };
    to?: string;
    children: React.ReactNode;
    requiredRoles: Roles[];
}

interface DispatchProps {
    push: Function;
}

export type Props = OwnProps & DispatchProps;

/**
 * A component that adds params to qs when clicked, but only if you have a specific role.
 */
export class RoleTableRowLink extends React.PureComponent<Props> {
    handleClick = (): void => {
        const { params, location, to, push: historyPush } = this.props;
        let search = params ? qs.stringify(params) : '';
        const pathname = to || location.pathname;

        if (!to && location.search) {
            search = `${location.search.substr(1)}${search && `&${search}`}`;
        }

        historyPush({
            pathname,
            search
        });
    };

    render(): React.ReactElement {
        const { children, requiredRoles } = this.props;

        return (
            <RoleGate
                requiredRoles={requiredRoles}
                fallback={<Table.Row>{children}</Table.Row>}
            >
                <Table.Row
                    onClick={this.handleClick}
                    style={{ cursor: 'pointer' }}
                >
                    {children}
                </Table.Row>
            </RoleGate>
        );
    }
}

export default withRouter(connect(null, { push })(RoleTableRowLink));
